import React, { PureComponent } from 'react';
import { Row, Col, Button } from 'reactstrap';
import axios from 'axios';
import DropdownCard from '../../components/DropdownCardNew';
import LoaderSpinner from '../Widgets/LoaderSpinner';
import Alert from '../Widgets/Alert';
import withAlertTimeout from '../../HOCs/withAlertTimeout';
import authProtection from '../../HOCs/authProtection';
import Dropdown from 'react-bootstrap/Dropdown';

class ClaimBusiness extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      allBusinesses: [],
      claimedBusinesses: [],
      newBusinesses: [],
      archivedBusinesses: [],
      completedBusinesses: [],
      displayBusinesses: [],
      successMessage: null,
      success: false,
      failure: false,
      sortedByText: '',
      displayBusinessesText: '',
    };

    this.renderClaims = this.renderClaims.bind(this);
    this.fetchClaimDetails = this.fetchClaimDetails.bind(this);
    this.approveClaim = this.approveClaim.bind(this);
    this.closeClaim = this.closeClaim.bind(this);
    this.archiveClaim = this.archiveClaim.bind(this);
    this.sortByDate = this.sortByDate.bind(this);
    this.sortByName = this.sortByName.bind(this);
    this.sortByCity = this.sortByCity.bind(this);
    this.showAllBusinesses = this.showAllBusinesses.bind(this);
    this.showAllUnapprovedBusinesses = this.showAllUnapprovedBusinesses.bind(
      this
    );
    this.showClaimedBusinesses = this.showClaimedBusinesses.bind(this);
    this.showNewBusinesses = this.showNewBusinesses.bind(this);
    this.showArchivedBusinesses = this.showArchivedBusinesses.bind(this);
    this.setClaimedAndNewBusinesses = this.setClaimedAndNewBusinesses.bind(
      this
    );
    this.sortTheData = this.sortTheData.bind(this);
  }

  componentDidMount() {
    this.fetchClaims();
  }

  fetchClaims() {
    const token = sessionStorage.getItem('token');

    const headers = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : null;
    this.setState({ fetchingClaims: true });

    const incompleteClaims = '/api/proxy/v2/businesses/claim?archive=false';
    const archivedClaims = '/api/proxy/v2/businesses/claim?archive=true';
    const completedClaims = '/api/proxy/v2/businesses/claim?completed=true';

    const incompleteClaimsRequest = axios.get(incompleteClaims, headers);
    const archivedClaimsRequest = axios.get(archivedClaims, headers);
    const completedClaimsRequest = axios.get(completedClaims, headers);

    // axios.all([
    //   incompleteClaimsRequest,
    //   archivedClaimsRequest,
    //   completedClaimsRequest
    // ])
    //   .then(axios.spread((...responses) => {
    //     this.setState({ allBusinesses: responses[0].data})
    //     console.log(responses[0].data)
    //     this.showAllBusinesses()
    //     this.sortByDate()
    //     this.setClaimedAndNewBusinesses()
    //     this.setState({ archivedBusinesses: responses[1].data, completedBusinesses: responses[2].data})
    //   }))
    //   .catch(err => {
    //     console.log(err)
    //     this.setState({ fetchingClaims: false })
    //   })

    axios
      .get(incompleteClaims, headers)
      .then(({ data }) => {
        this.setState({ allBusinesses: data });
        this.showAllBusinesses();
        this.sortByDate();
        this.setClaimedAndNewBusinesses();
      })
      .catch(err => {
        console.log(err);
      });

    axios
      .get(archivedClaims, headers)
      .then(({ data }) => {
        this.setState({
          archivedBusinesses: data,
        });
      })
      .catch(err => {
        console.log(err);
      });

    axios
      .get(completedClaims, headers)
      .then(({ data }) => {
        this.setState({
          completedBusinesses: data,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  setClaimedAndNewBusinesses() {
    this.setState({
      newBusinesses: [],
      claimedBusinesses: [],
    });
    this.state.allBusinesses.forEach(item => {
      if (item.data.note.indexOf('ADD BUSINESS') !== -1)
        this.setState({
          newBusinesses: [...this.state.newBusinesses, item],
        });
      else if (item.data.note.indexOf('CLAIM BUSINESS') !== -1)
        this.setState({
          claimedBusinesses: [...this.state.claimedBusinesses, item],
        });
    });
  }

  sortByDate() {
    const data = this.state.displayBusinesses;
    this.setState({ fetchingClaims: true });
    data.sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
    this.setState({ sortedByText: 'Date', fetchingClaims: false }, () =>
      this.forceUpdate()
    );
  }

  sortByName() {
    const data = this.state.displayBusinesses;
    this.setState({ fetchingClaims: true });
    data.sort((a, b) => {
      return a.business.name.toLowerCase() < b.business.name.toLowerCase()
        ? -1
        : a.business.name.toLowerCase() > b.business.name.toLowerCase()
        ? 1
        : 0;
    });
    this.setState({ sortedByText: 'Name', fetchingClaims: false }, () =>
      this.forceUpdate()
    );
  }

  sortByCity() {
    const data = this.state.displayBusinesses;
    this.setState({ fetchingClaims: true });
    data.sort((a, b) => {
      return a.business.location.address.city.toLowerCase() <
        b.business.location.address.city.toLowerCase()
        ? -1
        : a.business.location.address.city.toLowerCase() >
          b.business.location.address.city.toLowerCase()
        ? 1
        : 0;
    });
    this.setState({ sortedByText: 'City', fetchingClaims: false }, () =>
      this.forceUpdate()
    );
  }

  fetchClaimDetails(claimId) {
    return () => {
      return axios
        .get(`/claims/${claimId}`)
        .then(({ data }) => {
          this.setState({
            allBusinesses: {
              ...this.state.allBusinesses,
              [claimId]: data.data,
            },
          });
        })
        .catch(err => {
          console.log(err);
        });
    };
  }

  approveClaim(id) {
    return () => {
      const token = sessionStorage.getItem('token');

      return axios
        .post(
          `/api/proxy/v2/businesses/claim/control`,
          { id, accepted: true },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          this.closeClaim(id);
          this.showSuccess('Claim Approved');
          this.fetchClaims();
        })
        .catch(err => {
          console.log(err);
          this.props.showFailure();
        });
    };
  }

  denyClaim(id) {
    return () => {
      const token = sessionStorage.getItem('token');

      return axios
        .post(
          `/api/proxy/v2/businesses/claim/control`,
          { id, accepted: false },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          this.closeClaim(id);
          this.showSuccess('Claim Denied');
          this.fetchClaims();
        })
        .catch(err => {
          console.log(err);
          this.props.showFailure();
        });
    };
  }

  archiveClaim(id) {
    return () => {
      const token = sessionStorage.getItem('token');

      return axios
        .post(
          `/api/proxy/v2/businesses/claim/control`,
          { id, accepted: false, archive: true },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          //this.closeClaim(id)
          this.showSuccess('Claim Archived');
          this.fetchClaims();
        })
        .catch(err => {
          console.log(err);
          this.props.showFailure();
        });
    };
  }

  sortTheData() {
    const currentSort = this.state.sortedByText;
    if (currentSort === 'Date') this.sortByDate();
    else if (currentSort === 'Name') this.sortByName();
    else if (currentSort === 'City') this.sortByCity();
  }

  showAllBusinesses() {
    this.setState(
      {
        displayBusinesses: this.state.allBusinesses,
        displayBusinessesText: 'Unapproved Businesses',
      },
      () => {
        this.sortTheData();
      }
    );
  }

  showClaimedBusinesses() {
    this.setState(
      {
        displayBusinesses: this.state.claimedBusinesses,
        displayBusinessesText: 'Claimed Businesses',
      },
      () => {
        this.sortTheData();
      }
    );
  }

  showNewBusinesses() {
    this.setState(
      {
        displayBusinesses: this.state.newBusinesses,
        displayBusinessesText: 'New Businesses',
      },
      () => {
        this.sortTheData();
      }
    );
  }

  showArchivedBusinesses() {
    this.setState(
      {
        displayBusinesses: this.state.archivedBusinesses,
        displayBusinessesText: 'Archived Businesses',
      },
      () => {
        this.sortTheData();
      }
    );
  }

  showAllUnapprovedBusinesses() {
    this.setState(
      {
        displayBusinesses: this.state.completedBusinesses,
        displayBusinessesText: 'Completed Businesses',
      },
      () => {
        this.sortTheData();
      }
    );
  }

  renderClaims() {
    return (
      <div>
        <div
          className='form-actions'
          style={{
            width: 'min-width',
            textAlign: 'center',
            paddingBottom: '20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}>
          <Dropdown>
            <Dropdown.Toggle
              style={{ backgroundColor: '#20BED6' }}
              id='dropdown-sort'>
              Sort By {this.state.sortedByText}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={this.sortByDate}>
                Sort By Date
              </Dropdown.Item>
              <Dropdown.Item onClick={this.sortByName}>
                Sort By Name
              </Dropdown.Item>
              <Dropdown.Item onClick={this.sortByCity}>
                Sort By City
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown style={{ marginLeft: '15px' }}>
            <Dropdown.Toggle
              style={{ backgroundColor: '#20BED6' }}
              id='dropdown-filter'>
              {this.state.displayBusinessesText}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={this.showAllBusinesses}>
                Unapproved Businesses
              </Dropdown.Item>
              <Dropdown.Item onClick={this.showClaimedBusinesses}>
                Claimed Businesses
              </Dropdown.Item>
              <Dropdown.Item onClick={this.showNewBusinesses}>
                New Businesses
              </Dropdown.Item>
              <Dropdown.Item onClick={this.showArchivedBusinesses}>
                Archived Businesses
              </Dropdown.Item>
              <Dropdown.Item onClick={this.showAllUnapprovedBusinesses}>
                Completed Businesses
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {this.state.displayBusinesses.map(claim => (
          <DropdownCard
            title={claim.business.name}
            data={claim}
            finishedWithError={this.state.failure}
            onApprove={this.approveClaim(claim.id)}
            onDeny={this.denyClaim(claim.id)}
            onArchive={this.archiveClaim(claim.id)}
            key={claim.id}
          />
        ))}
      </div>
    );
  }

  closeClaim(claimId) {
    return axios
      .post(`/claims/close/${claimId}`)
      .then(() => {
        this.removeClaimFromState(claimId);
      })
      .catch(err => {
        console.log(err);
        this.props.showFailure();
      });
  }

  removeClaimFromState(claimId) {
    const claimsCopy = { ...this.state.allBusinesses };
    delete claimsCopy[claimId];

    this.setState({
      allBusinesses: claimsCopy,
      displayBusinesses: claimsCopy,
      claimIds: [...this.state.claimIds.filter(id => id !== claimId)],
    });

    this.setClaimedAndNewBusinesses();
  }

  showSuccess(message) {
    this.setState({ success: true, successMessage: message });
    this.props.showSuccess();
  }

  render() {
    return (
      <div className='animated fadeIn'>
        {
          <Alert
            active={this.props.success}
            message={this.state.successMessage || 'Success'}
          />
        }
        {
          <Alert
            type='danger'
            active={this.props.failure}
            message='Something went wrong, please try again'
          />
        }
        <Row>
          <Col xs='12'>
            {this.state.fetchingClaims ? (
              <LoaderSpinner />
            ) : (
              this.renderClaims()
            )}
            {!this.state.fetchingClaims && !this.state.allBusinesses.length && (
              <h3 style={{ textAlign: 'center ' }}>
                There are no pending claims at this time
              </h3>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default authProtection(withAlertTimeout(ClaimBusiness));



// WEBPACK FOOTER //
// ./src/views/Pages/NewClaimBusiness.js